module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": _vm.label,
      "required": _vm.required
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "value-key": "value"
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.formData),
      callback: function($$v) {
        _vm.formData = $$v
      },
      expression: "formData"
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-652985d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/selects/SelectClassificationType.vue
// module id = 1530
// module chunks = 0